/**
 *
 * Creates text anchors with the next format:
 * - Not punctuation symbols
 * - 5 words maximum
 * - Words separated by _
 * - Lowercase
 * Example:
 * - Input: 'This is Orca'
 * - Output: 'this_is_orca'
 */
export const createIdFromTitle = (title: string) => {
  const lowerCaseTitle = title.toLocaleLowerCase();
  const titleWithoutPuntuationMarks = lowerCaseTitle
    .replace(/[.,]/g, '')
    .replace(/['‘’"“”]/g, '')
    .replace(/[-]/g, ' ');
  const titleSplitted = titleWithoutPuntuationMarks.split(' ');
  const positions = titleSplitted.length > 5 ? 5 : titleSplitted.length;
  const id = titleSplitted.slice(0, positions).join('_');
  return id;
};
